// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .editorInput {
  min-height: 150px;
  resize: none;
  font-size: 15px;
  caret-color: rgb(5, 5, 5);
  position: relative;
  tab-size: 1;
  outline: 0;
  padding: 15px 10px;
  caret-color: #444;
} */

.editor_editor__ltr__xqpT2 {
  text-align: left;
}

.editor_editor__rtl__6SELy {
  text-align: right;
}

.editor_placeholder__iB99F {
  position: absolute;
  top: 15px;
  left: 10px;

  display: inline-block;
  overflow: hidden;

  -webkit-user-select: none;

          user-select: none;
  text-overflow: ellipsis;
  pointer-events: none;

  color: #999;

  font-size: 15px;
}

.editor_editor__textBold__XtP1p {
  font-weight: bold;
}

.editor_editor__textItalic__k-ZVK {
  font-style: italic;
}

.editor_editor__textUnderline__rA7xc {
  text-decoration: underline;
}

.editor_editor__textStrikethrough__JHtCU {
  text-decoration: line-through;
}

.editor_editor__textUnderlineStrikethrough__j1yyd {
  text-decoration: underline line-through;
}

.editor_editor__textCode__esOll {
  padding: 1px 0.25rem;

  background-color: rgb(240 242 245);

  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 94%;
}

.editor_editor__image__YQAbn {
  position: relative;

  display: inline-block;

  margin: 0;
  padding: 0;

  cursor: default;
  -webkit-user-select: none;
          user-select: none;

  border-radius: 5px;
}

img {
  max-width: 100%;

  cursor: default;

  border-radius: 5px;
}

.editor_tree-view-output__Qq-E- {
  position: relative;

  display: block;
  overflow: auto;

  max-height: 250px;
  margin: 1px auto 10px;
  padding: 5px;

  white-space: pre-wrap;

  color: #fff;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background: #222;

  font-size: 12px;
  line-height: 14px;
}

.editor_editor__code__fBcFf {
  position: relative;

  display: block;

  /* white-space: pre; */
  overflow-x: auto;

  margin: 0;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 20px 8px 8px 52px;

  tab-size: 2;

  background-color: rgb(240 242 245);

  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 13px;
  line-height: 1.53;
}

.editor_editor__code__fBcFf::before {
  position: absolute;
  top: 0;
  left: 0;

  min-width: 25px;
  padding: 8px;
  padding-top: 20px;

  content: attr(data-gutter);
  text-align: right;
  white-space: pre-wrap;

  color: #777;
  border-right: 1px solid #ccc;
  background-color: #eee;
}

.editor_editor__code__fBcFf::after {
  position: absolute;
  top: 0;
  right: 3px;

  padding: 3px;

  content: attr(data-highlight-language);
  text-transform: uppercase;

  color: rgb(0 0 0 / 50%);

  font-size: 10px;
}

.editor_editor__tokenComment__cXWby {
  color: slategray;
}

.editor_editor__tokenPunctuation__HL\\+6K {
  color: #999;
}

.editor_editor__tokenProperty__chppT {
  color: #905;
}

.editor_editor__tokenSelector__5jxPL {
  color: #690;
}

.editor_editor__tokenOperator__d9k7E {
  color: #9a6e3a;
}

.editor_editor__tokenAttr__YlBwU {
  color: #07a;
}

.editor_editor__tokenVariable__3mPjR {
  color: #e90;
}

.editor_editor__tokenFunction__di\\+PY {
  color: #dd4a68;
}

.editor_editor__paragraph__Dj0dZ {
  position: relative;

  margin: 0;
  margin-bottom: 8px;

  font-family: "Helvetica Thin", sans-serif;

  font-size: 12pt;
  line-height: 14pt;
}

.editor_editor__paragraph__Dj0dZ:last-child {
  margin-bottom: 4px;
}

.editor_editor__h1__gYqh0 {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Light", sans-serif;

  font-size: 24pt;
  line-height: 28pt;
}

.editor_editor__h2__2EFpA {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Light", sans-serif;

  font-size: 20pt;
  line-height: 24pt;
}

.editor_editor__h3__kNn1H {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Bold", sans-serif;

  font-size: 16pt;
  font-weight: 600;
  line-height: 18pt;
}

.editor_editor__h4__O9888 {
  margin: 10px 0;
  padding: 0;

  font-family: "HelveticaNeue Medium", sans-serif;

  font-size: 14pt;
  line-height: 16pt;
}

.editor_editor__h5__rPT8K {
  margin: 10px 0;
  padding: 0;

  color: rgb(0 0 0 / 80%);

  font-family: "HelveticaNeue Medium", sans-serif;

  font-size: 12pt;
  line-height: 14pt;
}

.editor_editor__h1__gYqh0:first-child,
.editor_editor__h2__2EFpA:first-child,
.editor_editor__h3__kNn1H:first-child,
.editor_editor__h4__O9888:first-child,
.editor_editor__h5__rPT8K:first-child {
  margin-top: 0;
}

.editor_editor__h1__gYqh0:last-child,
.editor_editor__h2__2EFpA:last-child,
.editor_editor__h3__kNn1H:last-child,
.editor_editor__h4__O9888:last-child,
.editor_editor__h5__rPT8K:last-child {
  margin-bottom: 4px;
}

.editor_editor__quote__d-xhx {
  margin: 0;
  margin-left: 5px;
  padding-left: 16px;

  color: rgb(101 103 107);
  border-left: 4px solid rgb(206 208 212);

  font-size: 15px;
  line-height: 24px;
}

.editor_editor__listOl__dbIEE {
  /* margin-left: 16px; */
  list-style-position: inside;

  line-height: 24px;
}

.editor_editor__listUl__ApFPU {
  list-style-position: inside;

  line-height: 24px;
}

.editor_editor__listItem__5RscY {
  margin: 8px 0;

  line-height: 24px;
}

.editor_editor__nestedListItem__AbITc {
  list-style-type: none;

  line-height: 24px;
}

.editor_editor__listItemChecked__NIeWF,
.editor_editor__listItemUnchecked__d3PHr {
  position: relative;

  margin-right: 8px;
  margin-left: 8px;
  padding-right: 24px;
  padding-left: 24px;

  list-style-type: none;

  outline: none;
}

.editor_editor__listItemChecked__NIeWF {
  text-decoration: line-through;
}

.editor_editor__listItemChecked__NIeWF::before,
.editor_editor__listItemUnchecked__d3PHr::before {
  position: absolute;
  top: 2px;
  left: 0;

  display: block;

  width: 16px;
  height: 16px;

  content: '';
  cursor: pointer;

  background-size: cover;
 }

 .editor_editor__listItemUnchecked__d3PHr[dir='rtl']::before,
.editor_editor__listItemChecked__NIeWF[dir='rtl']::before {
  right: 0;
  left: auto;
}

.editor_editor__listItemUnchecked__d3PHr:focus::before,
.editor_editor__listItemChecked__NIeWF:focus::before {
  border-radius: 2px;
  box-shadow: 0 0 0 2px #a6cdfe;
}

.editor_editor__listItemUnchecked__d3PHr::before {
  border: 1px solid #999;
  border-radius: 2px;
}

.editor_editor__listItemChecked__NIeWF::before {
  border: 1px solid rgb(61 135 245);
  border-radius: 2px;
  background-color: #3d87f5;
  background-repeat: no-repeat;
}

.editor_editor__listItemChecked__NIeWF::after {
  position: absolute;
  top: 6px;
  right: 7px;
  left: 7px;

  display: block;

  width: 3px;
  height: 6px;

  content: '';
  cursor: pointer;
  transform: rotate(45deg);

  border-width: 0 2px 2px 0;
  border-style: solid;
  border-color: #fff;
}

.editor_editor__tableContainer__YJ4W1 {
  overflow-x: auto;
  width:-webkit-max-content;
  width:max-content;
  max-width: 100%;
  margin: 15px 0;

  table-layout: fixed;
  border-spacing: 0;

  border-collapse: collapse;
}

.editor_editor__table__JGBGp {
  width:-webkit-max-content;
  width:max-content;
  margin: 15px 0;
  table-layout: fixed;
  border-spacing: 0;

  border-collapse: collapse;
  
}
.editor_editor__tableSelection__IgLwj *::selection {
  background-color: transparent;
}


.editor_editor__tablePreview__TNIa2 {
  overflow: auto hidden;

  width:98%;
  max-width: 98%;
  margin: 15px 0;

  table-layout: fixed;
  border-spacing: 0;

  border-collapse: collapse;
  
}


.editor_editor__tableSelection__IgLwj *::selection {
  background-color: transparent;
}

.editor_editor__tableSelected__aTbSy {
  outline: 2px solid rgb(60 132 244);
}

.editor_editor__tableCell__EsBKa {
  position: relative;

  width: 75px;
  min-width: 75px;
  padding: 6px 40px 6px 10px;

  text-align: start;
  vertical-align: top;

  border: 1px solid #bbb;
  outline: none;
}

.editor_editor__tableCellSortedIndicator__Qz\\+vQ {
  position: absolute;
  bottom: 0;
  left: 0;

  display: block;

  width: 100%;
  height: 4px;

  opacity: 0.5;
  background-color: #999;
}

.editor_editor__tableCellResizer__2xjKg {
  position: absolute;
  z-index: 10;
  top: 0;
  right: -4px;

  width: 8px;
  height: 100%;

  cursor: ew-resize;
}

.editor_editor__tableCellHeader__7NdFb {
  text-align: start;

  font-weight: 400;
}

.editor_editor__tableCellSelected__k3Qpl {
  background-color: #c9dbf0;
}

.editor_editor__tableCellPrimarySelected__nhdUx {
  position: absolute;
  z-index: 2;
  top: -1px;
  left: -1px;

  display: block;

  width: calc(100% - 2px);
  height: calc(100% - 2px);

  border: 2px solid rgb(60 132 244);
}

.editor_editor__tableCellEditing__jEAsY {
  border-radius: 3px;
  box-shadow: 0 0 5px rgb(0 0 0 / 40%);
}

.editor_editor__tableAddColumns__Mx96u {
  position: absolute;
  top: 0;
  right: -25px;

  width: 20px;
  height: 100%;

  cursor: pointer;
  animation: editor_table-controls__RkxfL 0.2s ease;

  border: 0;
  background-color: #eee;
}

.editor_editor__tableAddColumns__Mx96u::after {
  position: absolute;
  top: 0;
  left: 0;

  display: block;

  width: 100%;
  height: 100%;

  content: ' ';

  opacity: 0.4;
  background-repeat: no-repeat;
  background-position: center;

  /* background-image: url(../images/icons/plus.svg); */
  background-size: contain;
}

.editor_editor__tableAddColumns__Mx96u:hover {
  background-color: #112a47;
}

.editor_editor__tableAddRows__9nT0W {
  position: absolute;
  bottom: -25px;
  left: 0;

  width: calc(100% - 25px);
  height: 20px;

  cursor: pointer;
  animation: editor_table-controls__RkxfL 0.2s ease;

  border: 0;
  background-color: #eee;
}

.editor_editor__tableAddRows__9nT0W::after {
  position: absolute;
  top: 0;
  left: 0;

  display: block;

  width: 100%;
  height: 100%;

  content: ' ';

  opacity: 0.4;
  background-repeat: no-repeat;
  background-position: center;

  /* background-image: url(../images/icons/plus.svg); */
  background-size: contain;
}

.editor_editor__tableAddRows__9nT0W:hover {
  background-color: #c9dbf0;
}

@keyframes editor_table-controls__RkxfL {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.editor_editor__tableCellResizeRuler__XKHni {
  position: absolute;
  top: 0;

  display: block;

  width: 1px;
  height: 100%;

  background-color: rgb(60 132 244);
}

.editor_editor__tableCellActionButtonContainer__09f6C {
  position: absolute;
  z-index: 4;
  top: 6px;
  right: 0;

  display: block;

  width: 20px;
  height: 20px;
}

.editor_editor__tableCellActionButton__N\\+ffr {
  display: block;

  width: 20px;
  height: 20px;

  cursor: pointer;

  color: #222;
  border: 0;
  border-radius: 20px;
  background-color: #eee;
}

.editor_editor__tableCellActionButton__N\\+ffr:hover {
  background-color: #ddd;
}

.editor_editor__link__pi3aW {
  text-decoration: none;

  color: rgb(33 111 219) !important;
}

.editor_editor__link__pi3aW:hover {
  cursor: pointer;
  text-decoration: underline;
}


.editor_editor__tokenComment__cXWby {
  color: slategray;
}

.editor_editor__tokenPunctuation__HL\\+6K {
  color: #999;
}

.editor_editor__tokenProperty__chppT {
  color: #905;
}

.editor_editor__tokenSelector__5jxPL {
  color: #690;
}

.editor_editor__tokenOperator__d9k7E {
  color: #9a6e3a;
}

.editor_editor__tokenAttr__YlBwU {
  color: #07a;
}

.editor_editor__tokenVariable__3mPjR {
  color: #e90;
}

.editor_editor__tokenFunction__di\\+PY {
  color: #dd4a68;
}


.editor_editor__layoutContainer__Adpq3 {
  display: grid;
  grid-gap: 10px;
  gap: 10px;

  margin: 10px 0;
}

.editor_editor__layoutItem__hkFWz {
  padding: 8px 16px;

  border: 1px dashed #ddd;
}

.editor_editor__mark__agH0b {
  padding-bottom: 2px;

  background: #F7F5EE;
}

.editor_editor__markOverlap__e4p9B {
  background: #F7F5EE;
}

.editor_editor__markOverlap__e4p9B.editor_selected__gSsmz {
  background: #F7F5EE;
}

.editor_editor__mention__hPUfx {
  display: inline-block;

  max-width: 605px;
}


pre::-webkit-scrollbar {
  width: 10px;

  background: transparent;
}

pre::-webkit-scrollbar-thumb {
  background: #999;
}

`, "",{"version":3,"sources":["webpack://./src/components/form/Editor/theme/editor.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,qBAAqB;EACrB,gBAAgB;;EAEhB,yBAAiB;;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;;EAEpB,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;;EAEpB,kCAAkC;;EAElC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,qBAAqB;;EAErB,SAAS;EACT,UAAU;;EAEV,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;;EAEf,eAAe;;EAEf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,cAAc;;EAEd,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;;EAEZ,qBAAqB;;EAErB,WAAW;EACX,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,sBAAsB;EACtB,gBAAgB;;EAEhB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,0BAA0B;;EAE1B,WAAW;;EAEX,kCAAkC;;EAElC,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,eAAe;EACf,YAAY;EACZ,iBAAiB;;EAEjB,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;;EAErB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;;EAEV,YAAY;;EAEZ,sCAAsC;EACtC,yBAAyB;;EAEzB,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,SAAS;EACT,kBAAkB;;EAElB,yCAAyC;;EAEzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,8CAA8C;;EAE9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,8CAA8C;;EAE9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,6CAA6C;;EAE7C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;;EAEV,+CAA+C;;EAE/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;;EAEV,uBAAuB;;EAEvB,+CAA+C;;EAE/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;;EAElB,uBAAuB;EACvB,uCAAuC;;EAEvC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;;EAE3B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;;EAE3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;;EAErB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;;EAElB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;;EAElB,qBAAqB;;EAErB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,OAAO;;EAEP,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,eAAe;;EAEf,sBAAsB;CACvB;;CAEA;;EAEC,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;;EAET,cAAc;;EAEd,UAAU;EACV,WAAW;;EAEX,WAAW;EACX,eAAe;EACf,wBAAwB;;EAExB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAiB;EAAjB,iBAAiB;EACjB,eAAe;EACf,cAAc;;EAEd,mBAAmB;EACnB,iBAAiB;;EAEjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAiB;EAAjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;;EAEjB,yBAAyB;;AAE3B;AACA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,qBAAqB;;EAErB,SAAS;EACT,cAAc;EACd,cAAc;;EAEd,mBAAmB;EACnB,iBAAiB;;EAEjB,yBAAyB;;AAE3B;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,eAAe;EACf,0BAA0B;;EAE1B,iBAAiB;EACjB,mBAAmB;;EAEnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;;EAEP,cAAc;;EAEd,WAAW;EACX,WAAW;;EAEX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;;EAEX,UAAU;EACV,YAAY;;EAEZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;;EAEV,cAAc;;EAEd,uBAAuB;EACvB,wBAAwB;;EAExB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;;EAEZ,WAAW;EACX,YAAY;;EAEZ,eAAe;EACf,iDAAmC;;EAEnC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,YAAY;;EAEZ,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;;EAE3B,qDAAqD;EACrD,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;;EAEP,wBAAwB;EACxB,YAAY;;EAEZ,eAAe;EACf,iDAAmC;;EAEnC,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,YAAY;;EAEZ,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;;EAE3B,qDAAqD;EACrD,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;;EAEN,cAAc;;EAEd,UAAU;EACV,YAAY;;EAEZ,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;;EAER,cAAc;;EAEd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,eAAe;;EAEf,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;;EAErB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;;EAET,cAAc;AAChB;;AAEA;EACE,iBAAiB;;EAEjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;;EAErB,gBAAgB;AAClB;;;AAGA;EACE,WAAW;;EAEX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* .editorInput {\n  min-height: 150px;\n  resize: none;\n  font-size: 15px;\n  caret-color: rgb(5, 5, 5);\n  position: relative;\n  tab-size: 1;\n  outline: 0;\n  padding: 15px 10px;\n  caret-color: #444;\n} */\n\n.editor__ltr {\n  text-align: left;\n}\n\n.editor__rtl {\n  text-align: right;\n}\n\n.placeholder {\n  position: absolute;\n  top: 15px;\n  left: 10px;\n\n  display: inline-block;\n  overflow: hidden;\n\n  user-select: none;\n  text-overflow: ellipsis;\n  pointer-events: none;\n\n  color: #999;\n\n  font-size: 15px;\n}\n\n.editor__textBold {\n  font-weight: bold;\n}\n\n.editor__textItalic {\n  font-style: italic;\n}\n\n.editor__textUnderline {\n  text-decoration: underline;\n}\n\n.editor__textStrikethrough {\n  text-decoration: line-through;\n}\n\n.editor__textUnderlineStrikethrough {\n  text-decoration: underline line-through;\n}\n\n.editor__textCode {\n  padding: 1px 0.25rem;\n\n  background-color: rgb(240 242 245);\n\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 94%;\n}\n\n.editor__image {\n  position: relative;\n\n  display: inline-block;\n\n  margin: 0;\n  padding: 0;\n\n  cursor: default;\n  user-select: none;\n\n  border-radius: 5px;\n}\n\nimg {\n  max-width: 100%;\n\n  cursor: default;\n\n  border-radius: 5px;\n}\n\n.tree-view-output {\n  position: relative;\n\n  display: block;\n  overflow: auto;\n\n  max-height: 250px;\n  margin: 1px auto 10px;\n  padding: 5px;\n\n  white-space: pre-wrap;\n\n  color: #fff;\n  border-bottom-right-radius: 10px;\n  border-bottom-left-radius: 10px;\n  background: #222;\n\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.editor__code {\n  position: relative;\n\n  display: block;\n\n  /* white-space: pre; */\n  overflow-x: auto;\n\n  margin: 0;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  padding: 20px 8px 8px 52px;\n\n  tab-size: 2;\n\n  background-color: rgb(240 242 245);\n\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 13px;\n  line-height: 1.53;\n}\n\n.editor__code::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  min-width: 25px;\n  padding: 8px;\n  padding-top: 20px;\n\n  content: attr(data-gutter);\n  text-align: right;\n  white-space: pre-wrap;\n\n  color: #777;\n  border-right: 1px solid #ccc;\n  background-color: #eee;\n}\n\n.editor__code::after {\n  position: absolute;\n  top: 0;\n  right: 3px;\n\n  padding: 3px;\n\n  content: attr(data-highlight-language);\n  text-transform: uppercase;\n\n  color: rgb(0 0 0 / 50%);\n\n  font-size: 10px;\n}\n\n.editor__tokenComment {\n  color: slategray;\n}\n\n.editor__tokenPunctuation {\n  color: #999;\n}\n\n.editor__tokenProperty {\n  color: #905;\n}\n\n.editor__tokenSelector {\n  color: #690;\n}\n\n.editor__tokenOperator {\n  color: #9a6e3a;\n}\n\n.editor__tokenAttr {\n  color: #07a;\n}\n\n.editor__tokenVariable {\n  color: #e90;\n}\n\n.editor__tokenFunction {\n  color: #dd4a68;\n}\n\n.editor__paragraph {\n  position: relative;\n\n  margin: 0;\n  margin-bottom: 8px;\n\n  font-family: \"Helvetica Thin\", sans-serif;\n\n  font-size: 12pt;\n  line-height: 14pt;\n}\n\n.editor__paragraph:last-child {\n  margin-bottom: 4px;\n}\n\n.editor__h1 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Light\", sans-serif;\n\n  font-size: 24pt;\n  line-height: 28pt;\n}\n\n.editor__h2 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Light\", sans-serif;\n\n  font-size: 20pt;\n  line-height: 24pt;\n}\n\n.editor__h3 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Bold\", sans-serif;\n\n  font-size: 16pt;\n  font-weight: 600;\n  line-height: 18pt;\n}\n\n.editor__h4 {\n  margin: 10px 0;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Medium\", sans-serif;\n\n  font-size: 14pt;\n  line-height: 16pt;\n}\n\n.editor__h5 {\n  margin: 10px 0;\n  padding: 0;\n\n  color: rgb(0 0 0 / 80%);\n\n  font-family: \"HelveticaNeue Medium\", sans-serif;\n\n  font-size: 12pt;\n  line-height: 14pt;\n}\n\n.editor__h1:first-child,\n.editor__h2:first-child,\n.editor__h3:first-child,\n.editor__h4:first-child,\n.editor__h5:first-child {\n  margin-top: 0;\n}\n\n.editor__h1:last-child,\n.editor__h2:last-child,\n.editor__h3:last-child,\n.editor__h4:last-child,\n.editor__h5:last-child {\n  margin-bottom: 4px;\n}\n\n.editor__quote {\n  margin: 0;\n  margin-left: 5px;\n  padding-left: 16px;\n\n  color: rgb(101 103 107);\n  border-left: 4px solid rgb(206 208 212);\n\n  font-size: 15px;\n  line-height: 24px;\n}\n\n.editor__listOl {\n  /* margin-left: 16px; */\n  list-style-position: inside;\n\n  line-height: 24px;\n}\n\n.editor__listUl {\n  list-style-position: inside;\n\n  line-height: 24px;\n}\n\n.editor__listItem {\n  margin: 8px 0;\n\n  line-height: 24px;\n}\n\n.editor__nestedListItem {\n  list-style-type: none;\n\n  line-height: 24px;\n}\n\n.editor__listItemChecked,\n.editor__listItemUnchecked {\n  position: relative;\n\n  margin-right: 8px;\n  margin-left: 8px;\n  padding-right: 24px;\n  padding-left: 24px;\n\n  list-style-type: none;\n\n  outline: none;\n}\n\n.editor__listItemChecked {\n  text-decoration: line-through;\n}\n\n.editor__listItemChecked::before,\n.editor__listItemUnchecked::before {\n  position: absolute;\n  top: 2px;\n  left: 0;\n\n  display: block;\n\n  width: 16px;\n  height: 16px;\n\n  content: '';\n  cursor: pointer;\n\n  background-size: cover;\n }\n\n .editor__listItemUnchecked[dir='rtl']::before,\n.editor__listItemChecked[dir='rtl']::before {\n  right: 0;\n  left: auto;\n}\n\n.editor__listItemUnchecked:focus::before,\n.editor__listItemChecked:focus::before {\n  border-radius: 2px;\n  box-shadow: 0 0 0 2px #a6cdfe;\n}\n\n.editor__listItemUnchecked::before {\n  border: 1px solid #999;\n  border-radius: 2px;\n}\n\n.editor__listItemChecked::before {\n  border: 1px solid rgb(61 135 245);\n  border-radius: 2px;\n  background-color: #3d87f5;\n  background-repeat: no-repeat;\n}\n\n.editor__listItemChecked::after {\n  position: absolute;\n  top: 6px;\n  right: 7px;\n  left: 7px;\n\n  display: block;\n\n  width: 3px;\n  height: 6px;\n\n  content: '';\n  cursor: pointer;\n  transform: rotate(45deg);\n\n  border-width: 0 2px 2px 0;\n  border-style: solid;\n  border-color: #fff;\n}\n\n.editor__tableContainer {\n  overflow-x: auto;\n  width:max-content;\n  max-width: 100%;\n  margin: 15px 0;\n\n  table-layout: fixed;\n  border-spacing: 0;\n\n  border-collapse: collapse;\n}\n\n.editor__table {\n  width:max-content;\n  margin: 15px 0;\n  table-layout: fixed;\n  border-spacing: 0;\n\n  border-collapse: collapse;\n  \n}\n.editor__tableSelection *::selection {\n  background-color: transparent;\n}\n\n\n.editor__tablePreview {\n  overflow: auto hidden;\n\n  width:98%;\n  max-width: 98%;\n  margin: 15px 0;\n\n  table-layout: fixed;\n  border-spacing: 0;\n\n  border-collapse: collapse;\n  \n}\n\n\n.editor__tableSelection *::selection {\n  background-color: transparent;\n}\n\n.editor__tableSelected {\n  outline: 2px solid rgb(60 132 244);\n}\n\n.editor__tableCell {\n  position: relative;\n\n  width: 75px;\n  min-width: 75px;\n  padding: 6px 40px 6px 10px;\n\n  text-align: start;\n  vertical-align: top;\n\n  border: 1px solid #bbb;\n  outline: none;\n}\n\n.editor__tableCellSortedIndicator {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n\n  display: block;\n\n  width: 100%;\n  height: 4px;\n\n  opacity: 0.5;\n  background-color: #999;\n}\n\n.editor__tableCellResizer {\n  position: absolute;\n  z-index: 10;\n  top: 0;\n  right: -4px;\n\n  width: 8px;\n  height: 100%;\n\n  cursor: ew-resize;\n}\n\n.editor__tableCellHeader {\n  text-align: start;\n\n  font-weight: 400;\n}\n\n.editor__tableCellSelected {\n  background-color: #c9dbf0;\n}\n\n.editor__tableCellPrimarySelected {\n  position: absolute;\n  z-index: 2;\n  top: -1px;\n  left: -1px;\n\n  display: block;\n\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n\n  border: 2px solid rgb(60 132 244);\n}\n\n.editor__tableCellEditing {\n  border-radius: 3px;\n  box-shadow: 0 0 5px rgb(0 0 0 / 40%);\n}\n\n.editor__tableAddColumns {\n  position: absolute;\n  top: 0;\n  right: -25px;\n\n  width: 20px;\n  height: 100%;\n\n  cursor: pointer;\n  animation: table-controls 0.2s ease;\n\n  border: 0;\n  background-color: #eee;\n}\n\n.editor__tableAddColumns::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: block;\n\n  width: 100%;\n  height: 100%;\n\n  content: ' ';\n\n  opacity: 0.4;\n  background-repeat: no-repeat;\n  background-position: center;\n\n  /* background-image: url(../images/icons/plus.svg); */\n  background-size: contain;\n}\n\n.editor__tableAddColumns:hover {\n  background-color: #112a47;\n}\n\n.editor__tableAddRows {\n  position: absolute;\n  bottom: -25px;\n  left: 0;\n\n  width: calc(100% - 25px);\n  height: 20px;\n\n  cursor: pointer;\n  animation: table-controls 0.2s ease;\n\n  border: 0;\n  background-color: #eee;\n}\n\n.editor__tableAddRows::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: block;\n\n  width: 100%;\n  height: 100%;\n\n  content: ' ';\n\n  opacity: 0.4;\n  background-repeat: no-repeat;\n  background-position: center;\n\n  /* background-image: url(../images/icons/plus.svg); */\n  background-size: contain;\n}\n\n.editor__tableAddRows:hover {\n  background-color: #c9dbf0;\n}\n\n@keyframes table-controls {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.editor__tableCellResizeRuler {\n  position: absolute;\n  top: 0;\n\n  display: block;\n\n  width: 1px;\n  height: 100%;\n\n  background-color: rgb(60 132 244);\n}\n\n.editor__tableCellActionButtonContainer {\n  position: absolute;\n  z-index: 4;\n  top: 6px;\n  right: 0;\n\n  display: block;\n\n  width: 20px;\n  height: 20px;\n}\n\n.editor__tableCellActionButton {\n  display: block;\n\n  width: 20px;\n  height: 20px;\n\n  cursor: pointer;\n\n  color: #222;\n  border: 0;\n  border-radius: 20px;\n  background-color: #eee;\n}\n\n.editor__tableCellActionButton:hover {\n  background-color: #ddd;\n}\n\n.editor__link {\n  text-decoration: none;\n\n  color: rgb(33 111 219) !important;\n}\n\n.editor__link:hover {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n\n.editor__tokenComment {\n  color: slategray;\n}\n\n.editor__tokenPunctuation {\n  color: #999;\n}\n\n.editor__tokenProperty {\n  color: #905;\n}\n\n.editor__tokenSelector {\n  color: #690;\n}\n\n.editor__tokenOperator {\n  color: #9a6e3a;\n}\n\n.editor__tokenAttr {\n  color: #07a;\n}\n\n.editor__tokenVariable {\n  color: #e90;\n}\n\n.editor__tokenFunction {\n  color: #dd4a68;\n}\n\n\n.editor__layoutContainer {\n  display: grid;\n  gap: 10px;\n\n  margin: 10px 0;\n}\n\n.editor__layoutItem {\n  padding: 8px 16px;\n\n  border: 1px dashed #ddd;\n}\n\n.editor__mark {\n  padding-bottom: 2px;\n\n  background: #F7F5EE;\n}\n\n.editor__markOverlap {\n  background: #F7F5EE;\n}\n\n.editor__markOverlap.selected {\n  background: #F7F5EE;\n}\n\n.editor__mention {\n  display: inline-block;\n\n  max-width: 605px;\n}\n\n\npre::-webkit-scrollbar {\n  width: 10px;\n\n  background: transparent;\n}\n\npre::-webkit-scrollbar-thumb {\n  background: #999;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor__ltr": `editor_editor__ltr__xqpT2`,
	"editor__rtl": `editor_editor__rtl__6SELy`,
	"placeholder": `editor_placeholder__iB99F`,
	"editor__textBold": `editor_editor__textBold__XtP1p`,
	"editor__textItalic": `editor_editor__textItalic__k-ZVK`,
	"editor__textUnderline": `editor_editor__textUnderline__rA7xc`,
	"editor__textStrikethrough": `editor_editor__textStrikethrough__JHtCU`,
	"editor__textUnderlineStrikethrough": `editor_editor__textUnderlineStrikethrough__j1yyd`,
	"editor__textCode": `editor_editor__textCode__esOll`,
	"editor__image": `editor_editor__image__YQAbn`,
	"tree-view-output": `editor_tree-view-output__Qq-E-`,
	"editor__code": `editor_editor__code__fBcFf`,
	"editor__tokenComment": `editor_editor__tokenComment__cXWby`,
	"editor__tokenPunctuation": `editor_editor__tokenPunctuation__HL+6K`,
	"editor__tokenProperty": `editor_editor__tokenProperty__chppT`,
	"editor__tokenSelector": `editor_editor__tokenSelector__5jxPL`,
	"editor__tokenOperator": `editor_editor__tokenOperator__d9k7E`,
	"editor__tokenAttr": `editor_editor__tokenAttr__YlBwU`,
	"editor__tokenVariable": `editor_editor__tokenVariable__3mPjR`,
	"editor__tokenFunction": `editor_editor__tokenFunction__di+PY`,
	"editor__paragraph": `editor_editor__paragraph__Dj0dZ`,
	"editor__h1": `editor_editor__h1__gYqh0`,
	"editor__h2": `editor_editor__h2__2EFpA`,
	"editor__h3": `editor_editor__h3__kNn1H`,
	"editor__h4": `editor_editor__h4__O9888`,
	"editor__h5": `editor_editor__h5__rPT8K`,
	"editor__quote": `editor_editor__quote__d-xhx`,
	"editor__listOl": `editor_editor__listOl__dbIEE`,
	"editor__listUl": `editor_editor__listUl__ApFPU`,
	"editor__listItem": `editor_editor__listItem__5RscY`,
	"editor__nestedListItem": `editor_editor__nestedListItem__AbITc`,
	"editor__listItemChecked": `editor_editor__listItemChecked__NIeWF`,
	"editor__listItemUnchecked": `editor_editor__listItemUnchecked__d3PHr`,
	"editor__tableContainer": `editor_editor__tableContainer__YJ4W1`,
	"editor__table": `editor_editor__table__JGBGp`,
	"editor__tableSelection": `editor_editor__tableSelection__IgLwj`,
	"editor__tablePreview": `editor_editor__tablePreview__TNIa2`,
	"editor__tableSelected": `editor_editor__tableSelected__aTbSy`,
	"editor__tableCell": `editor_editor__tableCell__EsBKa`,
	"editor__tableCellSortedIndicator": `editor_editor__tableCellSortedIndicator__Qz+vQ`,
	"editor__tableCellResizer": `editor_editor__tableCellResizer__2xjKg`,
	"editor__tableCellHeader": `editor_editor__tableCellHeader__7NdFb`,
	"editor__tableCellSelected": `editor_editor__tableCellSelected__k3Qpl`,
	"editor__tableCellPrimarySelected": `editor_editor__tableCellPrimarySelected__nhdUx`,
	"editor__tableCellEditing": `editor_editor__tableCellEditing__jEAsY`,
	"editor__tableAddColumns": `editor_editor__tableAddColumns__Mx96u`,
	"table-controls": `editor_table-controls__RkxfL`,
	"editor__tableAddRows": `editor_editor__tableAddRows__9nT0W`,
	"editor__tableCellResizeRuler": `editor_editor__tableCellResizeRuler__XKHni`,
	"editor__tableCellActionButtonContainer": `editor_editor__tableCellActionButtonContainer__09f6C`,
	"editor__tableCellActionButton": `editor_editor__tableCellActionButton__N+ffr`,
	"editor__link": `editor_editor__link__pi3aW`,
	"editor__layoutContainer": `editor_editor__layoutContainer__Adpq3`,
	"editor__layoutItem": `editor_editor__layoutItem__hkFWz`,
	"editor__mark": `editor_editor__mark__agH0b`,
	"editor__markOverlap": `editor_editor__markOverlap__e4p9B`,
	"selected": `editor_selected__gSsmz`,
	"editor__mention": `editor_editor__mention__hPUfx`
};
export default ___CSS_LOADER_EXPORT___;
